module.exports = __webpack_public_path__ + "static/media/Icono_filtro.3f1de84d.svg";